import React from 'react'
import ReactDOM from 'react-dom'
import { syncHistoryWithStore } from 'react-router-redux'
import { hashHistory } from 'react-router'
import { createStore, components } from 'unity-core'
import { Root } from 'containers'
import * as loader from 'loader'
import { AppLoader } from 'components'
import { Environment } from 'utils'
import languages from 'i18n'

//RxJS
import 'rxjs/operators'

import 'ix/iterable'
import 'ix/asynciterable'
import 'ix/add/asynciterable-operators/map'
import 'ix/add/asynciterable-operators/distinct'

//Moment modules
require("moment-duration-format")(moment)
require("moment-timezone")

// Google protobuf timestamp
require('google-protobuf/google/protobuf/timestamp_pb.js');

//core Bootstrap JS + CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'

//React Bootstrap Table
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css'

//React Select
import 'react-select/dist/react-select.min.css'

//React Dates
import 'react-dates/lib/css/_datepicker.css'

//React-Toggle
import 'react-toggle/style.css'

//React-Tabs
import 'react-tabs/style/react-tabs.css'

//react-quill
import 'react-quill/dist/quill.snow.css'

//APP Style
import './styles'

// RequireJs can't load JS modules if it is not imported already.
// So we need certain imports here to avoid loading failure.
// Utools dependencies
import _JSONTree from 'react-json-tree'

// Rules library dependencies
import _Waypoint from 'react-waypoint'
import { Tab as _Tab } from 'react-tabs'

const store = createStore('start')

window.__lang = languages
window.__environment = Environment

//Sync the history from 'react-router' with 'redux' store
const history = syncHistoryWithStore(hashHistory, store)

const rootEl = document.getElementById('root');
ReactDOM.render(
  <AppLoader r={() => <Root store={store} history={history} />} />,
  rootEl)
